import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '../contexts/ToastContext';

/**
 * Bridge between TanStack Query mutation errors and the Toast system.
 * Subscribes to mutationCache — failed mutations show a toast unless their errors are handled locally.
 *
 * Place inside both <QueryClientProvider> and <ToastProvider>.
 */
export function QueryErrorBridge () {
  const qc = useQueryClient();
  const { addToast } = useToast();

  useEffect(() => {
    const unsubscribe = qc.getMutationCache().subscribe((event) => {
      if (
        event.type === 'updated' &&
        event.mutation?.state?.status === 'error' &&
        event.mutation.meta?.errorHandledLocally !== true
      ) {
        const error = event.mutation.state.error;
        const message = error?.message || 'Операция не удалась';
        addToast('Ошибка', message, 'error');
      }
    });
    return unsubscribe;
  }, [qc, addToast]);

  return null;
}
